import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../shared/user.service';
import { User } from '../shared/user.model';
import { Menu } from '../shared/menu.model';
import { CommonMenuHandelling } from '../shared/Menu/CommonMenuHandelling';
import { NotificationModel } from '../shared/NotificationModel.Model';
import { EventMessageModel } from '../shared/HR_ADMIN/Admin/EventMessageModel.Model';
import { BirthDayAnniversaryModel } from '../shared/HR_ADMIN/Employee/BirthDayAnniversaryModel.Model';
import { AttedanceCalendarModel } from '../shared/HR_ADMIN/Employee/AttedanceCalendarModel.model';
import { AdminMasterService }  from '../shared/HR_ADMIN/Admin/AdminMasterService.service';
import { HRPoliciesFormModel } from '../shared/HR_ADMIN/Admin/HRPoliciesFormModel.Model';
import { OptionsInput } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { CalendarComponent, FullCalendarModule } from 'ng-fullcalendar';

@Component
  ({
    selector: 'app-main-menu',
    templateUrl: './main-menu.component.html',
    styleUrls: ['./main-menu.component.css']
  })

export class MainMenuComponent implements OnInit 
{
  userClaims: any;
  Modules: Menu[] = [];
  SubMenues: Menu[] = [];
  Mod: any;
  check: number;
  tempmenu: Menu;

  HRPolicies : HRPoliciesFormModel[]=[];

  UserModel: User = new User();
  Users: User[] = [];
  User: any;
  SubmenuCount : number=0;
  TotalALLApplications : number=0;
  Notifications : NotificationModel[]=[];
  FormsRaised : NotificationModel[]=[];
  Noti : any;
  Events:EventMessageModel[]=[];
  MDMessages:EventMessageModel[]=[];
  Birthdays:BirthDayAnniversaryModel[]=[];
  MarriageAnniversarys:BirthDayAnniversaryModel[]=[];
  WorkAnniversarys:BirthDayAnniversaryModel[]=[];
  Attendances:AttedanceCalendarModel[]=[];
  
  options: OptionsInput;
  eventsModel: any;
 @ViewChild(FullCalendarModule, {static: false}) fullcalendar: CalendarComponent;
  PolicyCount :number=0;

  constructor(private AdminMasterService:AdminMasterService,private router: Router, private userService: UserService, private commonmenu:CommonMenuHandelling)
  {
    if (userService.selectdmoduleid != undefined) 
    {
      localStorage.setItem("moduleidstor", userService.selectdmoduleid.toString());
    }
  }

  ngOnInit() 
  {
    this.getMenues();
    this.GetLoginDetails();
    this.GetNotificationALL();
    this.GetEventMDMessageForDashBoard();
    this.GetEmployeeBirtDayForDashBoard();
    this.GetEmployeeMarriageAnniversaryForDashBoard();
    this.GetEmployeeWorkAnniversaryForDashBoard();
    this.UserModel.TotalAllApplication=0;
    this.GetHRPoliciesForms();
    var CurrentDate = new Date();
    let CurrentDateString = CurrentDate.toDateString();
    this.GetAttendanceDetailsForDashboard(CurrentDateString);
    this.GETNotificationForFormRaise();
  }

  getMenues() 
  {
    let t = localStorage.getItem('userToken');
    t = 'Bearer' + t;
    let moduleid = localStorage.getItem("moduleidstor")
    this.userService.MainMenuList(t, moduleid).then(x => 
    {
      this.Mod = x;
      Object.keys(this.Mod).forEach(key => 
      {
        // tslint:disable-next-line:no-unused-expression
        this.Mod[key];
        let menutemp = new Menu();
        menutemp = this.Mod[key];
        this.Modules.push(menutemp);
      });
    });
  }
 
  GetLoginDetails() 
  {
    this.UserModel=this.commonmenu.GetLoginDetails();
  }

  Logout()
  { 
    this.commonmenu.LogOut();
  }

  MainPages(menuid, moduleid, RouteName, j): void 
  {
    this.userService.selectdmoduleid = moduleid;
    this.userService.selectedmenuid = menuid;
    localStorage.setItem("selectedmodule", j);
    this.userService.SelectedMenuIndex = j;
    let t = localStorage.getItem('userToken');
    t = 'Bearer' + t;
    this.userService.GetSubMenuList(t, menuid).then(x => 
    {
      this.Mod = x;
      this.SubMenues = [];
      Object.keys(this.Mod).forEach(key =>
      {
        this.Mod[key];
        let menutemp = new Menu();
        menutemp = this.Mod[key];
        this.SubMenues.push(menutemp);
      });
      this.tempmenu = this.SubMenues[0];
      this.userService.SelectedMenu = this.tempmenu;
      localStorage.setItem("menuidstor", this.userService.SelectedMenu.MenuId.toString());
      this.userService.IsFormMainMenu=true;
      this.userService.MainMenuUrl = this.tempmenu.RouteName;
      this.router.navigate([this.tempmenu.RouteName]);
    });
  }

  OnDashboard() 
  {
    this.router.navigate(['/DashBoard']);
  }

  PageRedirectClick(moduleId,MainMenu,MenuId)
  {
    this.userService.selectdmoduleid = moduleId;
    this.userService.selectedmenuid = MainMenu;
    let t = localStorage.getItem('userToken');
    t = 'Bearer' + t;
    this.userService.GetSubMenuListForPageChange(t,moduleId,MainMenu,MenuId).then(x => 
    {
      this.Mod = x;
      this.SubMenues = [];
      Object.keys(this.Mod).forEach(key =>
      {
        this.Mod[key];
        let menutemp = new Menu();
        menutemp = this.Mod[key];
        localStorage.setItem("selectedmodule", menutemp.SelectedMenu.toString());
        if(menutemp.MenuId==MenuId)
        {
          localStorage.setItem("selectedSubMenu", menutemp.SelectedSubMenu.toString());
          this.SubmenuCount=menutemp.SelectedSubMenu;
        }
        this.userService.SelectedMenuIndex = menutemp.SelectedMenu;
        this.SubMenues.push(menutemp);
      });
      this.tempmenu = this.SubMenues[this.SubmenuCount];
      this.userService.SelectedMenu = this.tempmenu;
      this.userService.IsFormMainMenu = true;
      this.userService.MainMenuUrl = this.tempmenu.RouteName;
      this.router.navigate([this.tempmenu.RouteName]);
    });
  }

  GetNotificationALL()
  {  
    this.Notifications=[]
    let t =  localStorage.getItem('userToken');
    t = 'Bearer ' + t;
    this.userService.GetNotificationALL(t).then(x => 
    {
      this.Noti = x;
      Object.keys(this.Noti).forEach( key => 
      {
        this.Noti[key];
        let Notitemp = new NotificationModel();
        Notitemp = this.Noti[key];
        this.UserModel.TotalAllApplication=Notitemp.TotalAllApplication;
        if(Notitemp.TotalApplication > 0 && Notitemp.ApplicationType != 'Total Application')
        {
          this.Notifications.push(Notitemp);
        }
      });
    })
  }

  GetEventMDMessageForDashBoard()
  {  
    this.MDMessages=[];
    this.Events=[];
    let t =  localStorage.getItem('userToken');
    t = 'Bearer ' + t;
    this.userService.GetEventMDMessageForDashBoard(t).then(x => 
    {
      this.Events=[];
      this.MDMessages=[];
      this.Noti = x;
      Object.keys(this.Noti).forEach( key => 
      {
        this.Noti[key];
        let Notitemp = new EventMessageModel();
        Notitemp = this.Noti[key];
        if(Notitemp.MessageType=='Event')
        {
          this.Events.push(Notitemp);
        }
        else if(Notitemp.MessageType=='MD Message')
        {
          this.MDMessages.push(Notitemp);
        }
      });
    })
  }

  GetEmployeeBirtDayForDashBoard()
  {  
    this.Birthdays=[];
    let t =  localStorage.getItem('userToken');
    t = 'Bearer ' + t;
    this.userService.GetEmployeeBirtDayForDashBoard(t).then(x => 
    {
      this.Birthdays=[];
      this.Noti = x;
      Object.keys(this.Noti).forEach( key => 
      {
        this.Noti[key];
        let Notitemp = new BirthDayAnniversaryModel();
        Notitemp = this.Noti[key];
        this.Birthdays.push(Notitemp);
      });
    })
  }
  GetEmployeeMarriageAnniversaryForDashBoard()
  {  
    this.MarriageAnniversarys=[];
    let t =  localStorage.getItem('userToken');
    t = 'Bearer ' + t;
    this.userService.GetEmployeeMarriageAnniversaryForDashBoard(t).then(x => 
    {
      this.MarriageAnniversarys=[];
      this.Noti = x;
      Object.keys(this.Noti).forEach( key => 
      {
        this.Noti[key];
        let Notitemp = new BirthDayAnniversaryModel();
        Notitemp = this.Noti[key];
        this.MarriageAnniversarys.push(Notitemp);
      });
    })
  }
  GetEmployeeWorkAnniversaryForDashBoard()
  {  
    this.WorkAnniversarys=[];
    let t =  localStorage.getItem('userToken');
    t = 'Bearer ' + t;
    this.userService.GetEmployeeWorkAnniversaryForDashBoard(t).then(x => 
    {
      this.WorkAnniversarys=[];
      this.Noti = x;
      Object.keys(this.Noti).forEach( key => 
      {
        this.Noti[key];
        let Notitemp = new BirthDayAnniversaryModel();
        Notitemp = this.Noti[key];
        this.WorkAnniversarys.push(Notitemp);
      });
    })
  }

  download(fileName)
  {
    window.open(fileName, '_blank');
    //this.AdminMasterService.getFile(fileName);  
  }

  GetHRPoliciesForms()
  {  
    this.HRPolicies=[]
    let t =  localStorage.getItem('userToken');
    t = 'Bearer ' + t;
    this.AdminMasterService.GetHRPoliciesFormGV(t).then(x => 
    {
      this.Noti = x;
      Object.keys(this.Noti).forEach( key => 
      {
        this.PolicyCount=this.PolicyCount+1;
        this.Noti[key];
        let Notitemp = new HRPoliciesFormModel();
        Notitemp = this.Noti[key];
        this.HRPolicies.push(Notitemp);
      });
    })
  }

  getFormattedDate(date)
  {
    let newDate = new Date(date);
    return  newDate.getFullYear() + '-'+ ((newDate.getMonth() > 8) ? (newDate.getMonth() + 1) : ('0' + (newDate.getMonth() + 1))) + '-' + ((newDate.getDate() > 9) ? newDate.getDate() : ('0' + newDate.getDate()));
  }

  GetAttendanceDetailsForDashboard(AttendanceDate)
  {  
    this.Attendances=[];
    let t =  localStorage.getItem('userToken');
    t = 'Bearer ' + t;
    this.AdminMasterService.GetAttendanceDetailsForDashboard(t,AttendanceDate).then(x => 
    {
      this.Attendances=[];
      this.Noti = x;
      Object.keys(this.Noti).forEach( key => 
      {
        this.Noti[key];
        let Notitemp = new AttedanceCalendarModel();
        Notitemp = this.Noti[key];
        this.Attendances.push(Notitemp);
      });
      let itemList = []
      this.Attendances.forEach((key) => 
      {
        itemList.push({
        title: key.AttendanceStatus,
        description:key.InTime,
        start: this.getFormattedDate(key.AttendanceDate),
        end: this.getFormattedDate(key.AttendanceDate),
        textColor: key.AttendanceColor,
        // borderColor: 'orange',
        color: 'white',
      });
    })
    //console.log(itemList);
      this.options = 
      {
        fixedWeekCount : false,
        editable: false,
        events: itemList,
        header: {
          left: 'title',
          //center: 'title',
          right: 'prev today myCustomButton next'
        },
        plugins: [dayGridPlugin, interactionPlugin]
      };
    })
  }

  GETNotificationForFormRaise()
  {  
    this.FormsRaised=[];
    let t =  localStorage.getItem('userToken');
    t = 'Bearer ' + t;
    this.userService.GETNotificationForFormRaise(t).then(x => 
    {
      this.FormsRaised=[];
      this.Noti = x;
      Object.keys(this.Noti).forEach( key => 
      {
        this.Noti[key];
        let Notitemp = new NotificationModel();
        Notitemp = this.Noti[key];
        this.FormsRaised.push(Notitemp);
      });
    })
  }
}
